<template>
    <b-container>
        <b-row class="align-items-center mt-2">
            <b-col cols="auto">
                <h1 class="text-wrap">Welcome, {{ user.email }}</h1>
            </b-col>
            <b-col>
                <b-row align-h="between" class="align-items-center">
                    <b-col cols="auto">
                        <b-badge pill :variant="roleVariant">
                            {{ user.accessLevel | formatAccessLevel }}
                        </b-badge>
                    </b-col>
                    <b-col cols="auto">
                        <b-button variant="danger" size="sm" @click="logout()">
                            Log out
                        </b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-alert
            show
            v-if="user.accessLevel >= 6"
            variant="danger"
            class="mt-2 dense"
        >
            <b-row align-h="between" class="align-items-center">
                <b-col cols="auto">
                    <p class="">You have admin privileges.</p>
                </b-col>
                <b-col cols="auto">
                    <b-button
                        class="mr-3"
                        to="/dashboard"
                        variant="outline-dark"
                        size="sm"
                    >
                        Dashboard
                    </b-button>
                    <b-button to="/admin" variant="outline-danger" size="sm">
                        Control Panel
                    </b-button>
                </b-col>
            </b-row>
        </b-alert>
        <hr v-else />
    </b-container>
</template>

<script>
    import Cookies from 'js-cookie'

    export default {
        methods: {
            logout() {
                Cookies.remove('auth')
                window.location.replace('/login')
            }
        },
        computed: {
            user() {
                return JSON.parse(Cookies.get('auth'))
            },
            roleVariant() {
                return [null, 'dark', 'primary', null, null, 'warning', 'danger'][
                    this.user.accessLevel
                ]
            }
        }
    }
</script>

<style scoped>
</style>